export default {
	"5eb3691d4671db91e8cb1d20eac61229": "修改地址",
	"5a26bed5c41d0dd829351938187fa41c": "确认修改",
	"cf388516821123b8af72ec6857fac644": "请先选择地址",
	"445b471e1e1474044e8951d51c11930a": "修改失败",
	"2f4021322baf0748f78129c57c34a5c3": "修改地址成功",
	"3c507c8abe8c194e9dd70c6b5da3f657": "地址管理",
	"94725d8f14ecfd6d5849cb868fc767cb": "原地址",
	"6e2a9e4ce1c6d8bad171f15b9727b3ae": "选择新的收货地址",
	"4c0cfa335ec73e77ceb7fee59c61bb3a": "您还没有收货地址哦～"
}
